export enum IssueSeverityEnum {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  CRITICAL = 'Critical',
}

export type IssueSeverityType = 'Low' | 'Medium' | 'High' | 'Critical';
export type IssueSeverityTypeWithNull = IssueSeverityType | 'null';
